import { redirect, type LoaderFunctionArgs } from "@remix-run/node";
import AuthLayout from "~/layouts/AuthLayout";
import { getUser } from "~/services/auth/auth.server";

export async function loader({ request }: LoaderFunctionArgs) {
  // Kullanıcı giriş yapmışsa ana sayfaya yönlendir
  const user = await getUser(request);

  if (user) {
    // Kullanıcı giriş yapmışsa ana sayfaya yönlendir
    return redirect("/");
  }

  // Kullanıcı giriş yapmamışsa devam et
  return null;
}

export default function AuthLayoutRoute() {
  return <AuthLayout />;
}
